import { render, staticRenderFns } from "./notebook.vue?vue&type=template&id=274d11d1&scoped=true&"
import script from "./notebook.vue?vue&type=script&lang=js&"
export * from "./notebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274d11d1",
  null
  
)

export default component.exports